import React, { useContext } from 'react';
import { CropRatios, ImageCropperContext } from '../../../libs/gs-component-image-upload';

import styles from './index.scss';

interface Props {
  ratioLookup: { [index: string]: number } | undefined | null;
  defaultRatio: string | undefined | null;
}

const PhotoCropRatios: React.FC<Props> = ({ ratioLookup, defaultRatio }) => {
  const { updateAspectRatio } = useContext(ImageCropperContext);
  const ratios = Object.keys(ratioLookup || {});

  if (!ratios || ratios.length <= 1) {
    return null;
  }

  const onRatioChange = (ratio: string): void => {
    const lookup = ratioLookup || {};
    updateAspectRatio(lookup[ratio]);
  };

  return (
    <>
      <div className={styles.separator} />
      <CropRatios onChange={onRatioChange} ratios={ratios} defaultRatio={defaultRatio || ''} />
    </>
  );
};

export default PhotoCropRatios;
